import ReactGA from 'react-ga4';

declare global {
    interface Window {
        dataLayer?: any[];
        gtag?: (...args: any[]) => void;
        gaLoaded?: boolean;
    }
}

export const GA_EXPIRES_TIME_DAYS = 28;
export const GA_EXPIRES_TIME = 60 * 60 * 24 * GA_EXPIRES_TIME_DAYS;

const GA_ID = process.env.GATSBY_GA_TRACKING_ID!;
let isGAInitialized = false;

let isGAAnonymousInitialized = false;

export function initGA() {
    if (!GA_ID || isGAInitialized) return;

    ReactGA.reset();
    ReactGA.initialize(GA_ID, {gaOptions: {cookie_expires: 0,}, gtagOptions: {cookie_expires: GA_EXPIRES_TIME,}});
    isGAInitialized = true;
    isGAAnonymousInitialized = false;
    ReactGA.send({hitType: 'pageview', page: window.location.pathname});
}

export function sendPageView(path: string) {
    if (!isGAInitialized && !isGAAnonymousInitialized) return;
    ReactGA.send({hitType: 'pageview', page: path});
}

export function loadGAAnonymously() {
    if (!GA_ID || typeof window === 'undefined') return;

    isGAAnonymousInitialized = true;
    ReactGA.reset();
    ReactGA.initialize(GA_ID, {
        gaOptions: {
            anonymize_ip: true,
            storage: 'none',
            client_storage: 'none',
            allow_google_signals: false,
            allow_ad_personalization_signals: false
        },
        gtagOptions: {
            anonymize_ip: true,
            storage: 'none',
            client_storage: 'none',
            allow_google_signals: false,
            allow_ad_personalization_signals: false
        }
    });

    ReactGA.send({hitType: 'pageview', page: window.location.pathname});
}